import { RenderContextComponent } from '../../../../../../models/base/render-context-component';
import { Component } from '@angular/core';

@Component({
  selector: 'app-card-content',
  template: '',
  standalone: false
})
export abstract class CardContentComponent extends RenderContextComponent {}
